<template>
  <div class="checkbox-content" :style="outstyle">
    <span v-if="front">{{label}}</span>
  <div class="checkbox" @click="selectedBox">
      <img v-if="selected"
      :src="checkedImg &&
      checkedImg || require('@/assets/images/users/radio_bg.png')" alt="">
      <img v-else
      :src="unCheckedImg &&
      unCheckedImg || require('@/assets/images/users/radio_unbg.png')" alt="">
  </div>
    <span v-if="!front">{{label}}</span>
  </div>
</template>

<script>
export default {
  props: {
    checkedImg: String,
    unCheckedImg: String,
    checkedStatus: Boolean,
    outstyle: String,
    front: {
      type: Boolean,
      default: true,
    },
    label: String,
  },
  data() {
    return {
      selected: this.checkedStatus || false,
    };
  },
  watch: {
    checkedStatus(val) {
      this.selected = val;
    },
  },
  methods: {
    selectedBox() {
      this.selected = !this.selected;
      this.$emit('selectedCheck', this.selected);
    },
  },

};
</script>
<style lang="scss" scoped>
  .checkbox-content {
    display: flex;
    align-items: center;
    span {
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #5A607F;
    }
    .checkbox {
      display: flex;
      align-items: center;
      padding-left: 14px;
      padding-right: 14px;
    }
  }
</style>
